import React from "react";
import PropTypes from "prop-types";

import "./sideNavbar.scss";

import SideNavbarItem from "../SideNavbarItem/sideNavbarItem";
import getParentTopicData from "../../utils/helperFunctions";

const SideNavbar = ({ uri = "", allPagesData = {} }) => {
  const {
    activeChildUri = "",
    childPages = [],
  } = getParentTopicData(uri, allPagesData);

  return (
    <div className="side-navbar">
      {childPages?.map(uri => {
        return (
          <SideNavbarItem
            uri={uri}
            allPagesData={allPagesData}
            key={uri}
            activeChild={activeChildUri === uri}
          />
        );
      })}
    </div>
  );
};

SideNavbar.propTypes = {
  pages: PropTypes.array,
  uri: PropTypes.string,
  allPagesData: PropTypes.object,
};
export default SideNavbar;
